<!--  -->
<template>
  <div class="container">
    <img
      src="../../assets/register/fetal-monitor/register.png"
      alt="超声多普勒胎儿监护仪注册证"
      v-if="pageType == 0"
    />
    <img
      src="../../assets/register/Multiple-signs.jpg"
      alt="多体征注册证"
      v-if="pageType == 1"
    />
    <img
      src="../../assets/register/ovulation/1.png"
      alt="排卵试纸注册证"
      v-if="pageType == 2"
    />
     <img
      src="../../assets/register/ovulation/2.png"
      alt="排卵试纸注册证"
      v-if="pageType == 2"
    />
    <img
      src="../../assets/register/ovulation/3.png"
      alt="排卵试纸注册证"
      v-if="pageType == 2"
    />
     <img
      src="../../assets/register/ovulation/4.png"
      alt="排卵试纸注册证"
      v-if="pageType == 2"
    />
    <img
      src="../../assets/register/ovulation/5.png"
      alt="排卵试纸注册证"
      v-if="pageType == 2"
    />
     <img
      src="../../assets/register/ovulation/6.png"
      alt="排卵试纸注册证"
      v-if="pageType == 2"
    />
  </div> 
</template>

<script>
export default {
  name: "",
  data() {
    return {
      pageType: 0
    };
  },

  props: [],

  watch: {},

  components: {},

  computed: {},

  created() {
    if (this.$route.query.pageType) {
      this.pageType = this.$route.query.pageType;
    }
  },

  methods: {}
};
</script>
<style lang="scss" scoped>
.container {
  padding-top: 30px;

  img {
    max-width:80vw; 

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/license/register.vue